import React, { Component } from "react";
import deleteButton from '@images/close.svg';
import addButton from '@images/addrow_icon.svg';
import NumberTools from "@components/NumberTools";
import SessionStateManager from "@components/SessionStateManager";
import ValidationsManager from "@components/ValidationsManager";
import UpdateDialog from '@components/UpdateDialog';
import SupportAlert from "@components/SupportAlert";
import { CustomDialog, useDialog } from 'react-st-modal';
import styles from '../questionnaire.module.css';

class RnDOutsourcedQuestion extends Component {
    state = {
        loading: true,
        sessionStateChanged: false,
        outsourcedToValues: new Map(),
        outsourcedToRows: [],
        outsourcedToTotal: 0,
        rowFactIds: null,
    }

    constructor(props) {
        super(props);
    }

    async componentDidMount() {
        this.setState({ loading: true });

        this.setState({ loading: false });
    }

    CONFIG_DEFAULT_MINIMUM_ROWS = 3;
    CONFIG_DEFAULT_MAXIMUM_ROWS_TO_ADD = 20;
    OUTSOURCED_TO_FACT_ID = this.props.questionState.questionFactStates.sort((a, b) => (a.sequenceNumberY > b.sequenceNumberY) ? 1 : -1)[0].questionFactId;
    PERCENTAGE_FACT_ID = this.props.questionState.questionFactStates.sort((a, b) => (a.sequenceNumberY > b.sequenceNumberY) ? 1 : -1)[1].questionFactId;

    async handleOnChange(evt, questionFactId, ordinal, numericInput) {
        let key = questionFactId + '_' + ordinal;
        let value = evt.target.value;

        if (numericInput && !NumberTools.isValidDecimalNumber(value)) {
            evt.preventDefault();
        } else {
            if (this.props.captureType !== undefined && this.props.captureType !== null && this.props.captureType == 'RESEARCHER_UPDATE') {
                const result = await CustomDialog(
                    <UpdateAuditDialog
                        currentAnswer={SessionStateManager.getSessionValue(key)}
                        numericInput={numericInput}
                        startEndornment={numericInput ? 'R' : null}
                    />,
                    {
                        className: styles.updateAuditDialog,
                        title: 'Update Submitted Value',
                        showCloseIcon: false,
                        isFocusLock: true,
                        isCanClose: true, // setting this to false prevents the dialog from being closed when clicking away
                    }
                );

                if (result !== undefined && result !== null && result.confirmed !== undefined && result.confirmed !== null && result.confirmed == true) {
                    // Setting only the percentage questionFacts to zero when removed ie. nulled
                    if (questionFactId === this.PERCENTAGE_FACT_ID) {
                        let newValue = ((result.newValue !== undefined && result.newValue !== null && result.newValue !== '') ? result.newValue : 0)
                        SessionStateManager.setSessionValueWithoutDependenciesValidation(key, newValue, this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, result.sourceOfData, result.reason);
                    } else {
                        SessionStateManager.setSessionValueWithoutDependenciesValidation(key, (numericInput ? result.newValue.toString().replace(/\s/g, '') : result.newValue), this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, result.sourceOfData, result.reason);
                    }
                    this.setState({ sessionStateChanged: true });
                } else {
                    evt.preventDefault();
                }
            } else {

                if (questionFactId === this.PERCENTAGE_FACT_ID) {
                    value = ((value !== undefined && value !== null && value !== '') ? parseFloat((numericInput ? value.toString().replace(/\s/g, '') : value)) : 0)
                }
                SessionStateManager.setSessionValueWithoutDependenciesValidation(key, value, this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, "", "");

                setTimeout(() => {
                    for (let ord = 0; ord <= ordinal; ord++) {
                        let rowKey = questionFactId + '_' + ord;
                        if (!SessionStateManager.hasChangeListEntry(rowKey)) {
                            let rowValue = ((questionFactId !== this.PERCENTAGE_FACT_ID) ? SessionStateManager.getSessionValue(rowKey) : ((SessionStateManager.getSessionValue(rowKey) !== undefined && SessionStateManager.getSessionValue(rowKey) !== null && SessionStateManager.getSessionValue(rowKey) !== '') ? SessionStateManager.getSessionValue(rowKey) : 0));
                            rowValue = (rowValue !== undefined && rowValue !== null) ? rowValue : '';
                            SessionStateManager.setSessionValueWithoutDependenciesValidation(rowKey, rowValue, this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, "", "");
                        }
                    }
                }, 0);
                this.setState({ sessionStateChanged: true });
            }
            if (this.props.onChange !== undefined && this.props.onChange !== null) {
                this.props.onChange(evt);
            }
        }
    }

    handleOnBlur = (evt) => {
        if (this.props.onBlur !== undefined && this.props.onBlur !== null) {
            this.props.onBlur(evt);
        }
    }

    handleAddOutsourcedToRow = (evt, factIds) => {
        let rowsToAdd = parseInt(this.rowCountInput?.value || 1);
        if (rowsToAdd <= this.CONFIG_DEFAULT_MAXIMUM_ROWS_TO_ADD) {

            rowsToAdd = ((rowsToAdd > this.CONFIG_DEFAULT_MAXIMUM_ROWS_TO_ADD) ? (this.CONFIG_DEFAULT_MAXIMUM_ROWS_TO_ADD) : rowsToAdd);
            const newRows = [];

            // If more rows are required, then lets always make sure that the default minimum rows are in the session state 
            for (let ordinal = 0; ordinal < this.CONFIG_DEFAULT_MINIMUM_ROWS; ordinal++) {
                factIds.forEach(factId => {
                    let thisKey = factId + '_' + ordinal;
                    if (!SessionStateManager.hasSessionValueByKey(thisKey)) {
                        SessionStateManager.setSessionValueWithoutDependenciesValidation(thisKey, ((factId === this.PERCENTAGE_FACT_ID) ? 0 : ''), this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, "", "");
                    }

                    if (SessionStateManager.hasSessionValueByKey(thisKey) && (SessionStateManager.getSessionValue(thisKey) === undefined || SessionStateManager.getSessionValue(thisKey) === null)) {
                        SessionStateManager.setSessionValueWithoutDependenciesValidation(thisKey, ((factId === this.PERCENTAGE_FACT_ID) ? 0 : ''), this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, "", "");
                    }

                });
            }

            for (let offset = 0; offset < rowsToAdd; offset++) {
                const item = {
                    ordinalEntry: parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + this.state.outsourcedToRows.length + offset),
                    factIds: factIds
                };

                factIds.forEach(factId => {
                    let thisKey = factId + '_' + (this.CONFIG_DEFAULT_MINIMUM_ROWS + this.state.outsourcedToRows.length + offset).toString(); //
                    if (!SessionStateManager.hasSessionValueByKey(thisKey)) {
                        SessionStateManager.setSessionValueWithoutDependenciesValidation(thisKey, ((factId === this.PERCENTAGE_FACT_ID) ? 0 : ''), this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, "", "");
                    }
                });

                newRows.push(item);
            }

            this.setState({
                outsourcedToRows: [...this.state.outsourcedToRows, ...newRows],
                sessionStateChanged: true
            });
        } else {
            evt.preventDefault();
        }
    };

    addOutsourcedToRow = (rowsToAdd, factIds) => {
        if (rowsToAdd > 0) {
            let newRows = [];
            for (let offset = 0; offset < rowsToAdd; offset++) {
                const item = {
                    ordinalEntry: parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + this.state.outsourcedToRows.length + offset),
                    factIds: factIds
                };

                factIds.forEach(factId => {
                    let thisKey = factId + '_' + (this.CONFIG_DEFAULT_MINIMUM_ROWS + this.state.outsourcedToRows.length + offset).toString(); //
                    if (!SessionStateManager.hasSessionValueByKey(thisKey)) {
                        SessionStateManager.setSessionValueWithoutDependenciesValidation(thisKey, ((factId === this.PERCENTAGE_FACT_ID) ? 0 : ''), this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, "", "");
                    }
                });

                newRows.push(item);
            }
            this.setState({
                outsourcedToRows: [...this.state.outsourcedToRows, ...newRows],
                sessionStateChanged: true
            });
        }
    };

    handleRemoveOutsourcedToRow = (evt) => {
        if (this.state.outsourcedToRows.length > 0) {
            let rowToRemove = this.state.outsourcedToRows.sort((a, b) => a.ordinalEntry > b.ordinalEntry ? 1 : -1)[this.state.outsourcedToRows.length - 1];

            // Updating total by deleting all values for factIds of this row and re-calculating total
            rowToRemove?.factIds?.forEach(factId => {
                let thisKey = 'rnd_outsourced_' + rowToRemove.ordinalEntry + '_' + factId
                this.state.outsourcedToValues.delete(thisKey);
            });

            let sum = parseFloat(0);
            this.state.outsourcedToValues?.forEach((value, key) => {
                sum = sum + parseFloat(value)
            });
            this.setState({ outsourcedToTotal: sum });

            rowToRemove?.factIds?.forEach(factId => {
                let thisKey = factId + '_' + rowToRemove.ordinalEntry;
                SessionStateManager.setSessionValueWithoutDependenciesValidation(thisKey, ((factId === this.PERCENTAGE_FACT_ID) ? 0 : ''), this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId);
                SessionStateManager.deleteSessionValue(thisKey);
            });
            this.setState({ sessionStateChanged: true });

            this.setState({
                outsourcedToRows: this.state.outsourcedToRows.sort((a, b) => a.ordinalEntry > b.ordinalEntry ? 1 : -1).slice(0, -1)
            });
        }
    };

    calculatePercentageTotal(valueFactId) {
        let sum = parseFloat(0);
        let activityCodes = SessionStateManager.allEntriesByQuestionFactId(valueFactId);

        activityCodes.forEach((item) => {
            sum = sum + parseFloat(item.value !== null && item.value !== '' && !isNaN(item.value) ? item.value : 0);
        });

        return sum;
    }

    render() {
        if (this.state.loading === true) {
            return <p>Loading...</p>
        } else {
            let rowFactIds = [this.OUTSOURCED_TO_FACT_ID, this.PERCENTAGE_FACT_ID];
            if (this.state.rowFactIds == null) {
                this.setState({ rowFactIds: rowFactIds });
            }

            let initialRows = 0;

            let activitiesCount = SessionStateManager.countEntriesByQuestionFactId(this.OUTSOURCED_TO_FACT_ID);
            initialRows = activitiesCount;

            let percentCount = SessionStateManager.countEntriesByQuestionFactId(this.PERCENTAGE_FACT_ID);
            initialRows = percentCount > initialRows ? percentCount : initialRows;

            let rowsToAdd = (this.CONFIG_DEFAULT_MINIMUM_ROWS < initialRows) ? (initialRows - this.CONFIG_DEFAULT_MINIMUM_ROWS - this.state.outsourcedToRows.length) : 0;

            this.addOutsourcedToRow(rowsToAdd, rowFactIds);

            let defaultOrdinals = [];
            for (var ordinal = 0; ordinal < this.CONFIG_DEFAULT_MINIMUM_ROWS; ordinal++) {
                defaultOrdinals.push(ordinal);
            }

            let rndTable = 'rnd_row_';
            let tableRowKey = 0;
            return <div className={styles.RndOutsourcedQuestionContainer}>
                <table className="table">
                    <thead>
                        <tr key={rndTable + (tableRowKey++)}>
                            <th className={styles.centerAlignVertically}>Row</th>
                            <th className={styles.centerAlignVertically} width="70%">Outsourced To</th>
                            <th className={styles.centerAlignVertically} width="30%">Approximate Value R’000s (excl. VAT)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {defaultOrdinals.sort().map(ordinal => (
                            <tr key={rndTable + (tableRowKey++)}>
                                <td key={'rnd_table_column_' + ordinal} className={styles.centerAlignVertically}>
                                    {ordinal + 1}
                                </td>
                                <td
                                    className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, this.OUTSOURCED_TO_FACT_ID + '_' + ordinal) ? styles.tableInputBoxUpdated : null}
                                >
                                    <input
                                        className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, this.OUTSOURCED_TO_FACT_ID + '_' + ordinal) ? styles.tableInputBoxUpdated : styles.tableInputBox}
                                        type="text"
                                        questionId={this.props.questionState.question.id}
                                        ordinalEntry={ordinal}
                                        questionFactId={this.OUTSOURCED_TO_FACT_ID}
                                        value={SessionStateManager.getSessionValue(this.OUTSOURCED_TO_FACT_ID + '_' + ordinal)}
                                        onChange={evt => this.handleOnChange(evt, this.OUTSOURCED_TO_FACT_ID, ordinal, false)}
                                        onBlur={this.handleOnBlur}
                                        placeholder={'Outsourced To'}
                                    />
                                </td>
                                <td
                                    className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, this.PERCENTAGE_FACT_ID + '_' + ordinal) ? styles.tableInputBoxUpdated : null}
                                >
                                    <div className={styles.flexCenterFitContent}>
                                        <span className="inputRandSign">R</span>
                                        <input
                                            className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, this.PERCENTAGE_FACT_ID + '_' + ordinal) ? styles.tableInputBoxUpdated : styles.tableInputBox}
                                            type="text"
                                            value={NumberTools.transformToCurrency(SessionStateManager.getSessionValue(this.PERCENTAGE_FACT_ID + '_' + ordinal))}
                                            onClick={(evt) => {
                                                if (this.props.captureType !== undefined && this.props.captureType !== null && this.props.captureType == 'RESEARCHER_UPDATE') {
                                                    this.handleOnChange(evt, this.PERCENTAGE_FACT_ID, ordinal, true);
                                                }
                                            }}
                                            onKeyUp={(event) => { if (!/[0-9|\.]/.test(event.key) || (this.props.captureType !== undefined && this.props.captureType !== null && this.props.captureType == 'RESEARCHER_UPDATE')) { event.preventDefault(); } }}
                                            onChange={evt => this.handleOnChange(evt, this.PERCENTAGE_FACT_ID, ordinal, true)}
                                            onBlur={this.handleOnBlur}
                                            questionId={this.props.questionState.question.id}
                                            ordinalEntry={0}
                                            questionFactId={this.PERCENTAGE_FACT_ID}
                                            placeholder={0}
                                        />
                                    </div>
                                </td>
                            </tr>)
                        )}

                        {this.state.outsourcedToRows.map((item, idx) => (
                            <tr id="addr0" key={rndTable + (tableRowKey++)}>
                                <td key={'rnd_table_column_' + parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx)} className={styles.centerAlignVertically}>
                                    {parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx) + 1}
                                </td>
                                <td
                                    className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, this.OUTSOURCED_TO_FACT_ID + '_' + parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx)) ? styles.tableInputBoxUpdated : null}
                                >
                                    <input
                                        className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, this.OUTSOURCED_TO_FACT_ID + '_' + parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx)) ? styles.tableInputBoxUpdated : styles.tableInputBox}
                                        type="text"
                                        questionId={this.props.questionState.question.id}
                                        ordinalEntry={parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx)}
                                        questionFactId={this.OUTSOURCED_TO_FACT_ID}
                                        value={SessionStateManager.getSessionValue(this.OUTSOURCED_TO_FACT_ID + '_' + parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx))}
                                        onChange={evt => this.handleOnChange(evt, this.OUTSOURCED_TO_FACT_ID, parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx), false)}
                                        onBlur={this.handleOnBlur}
                                        placeholder={'Outsourced to'}
                                    />
                                </td>
                                <td
                                    className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, this.PERCENTAGE_FACT_ID + '_' + parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx)) ? styles.tableInputBoxUpdated : null}
                                >
                                    <div className={styles.flexCenterFitContent}>
                                        <span className="inputRandSign">R</span>
                                        <input
                                            className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, this.PERCENTAGE_FACT_ID + '_' + parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx)) ? styles.tableInputBoxUpdated : styles.tableInputBox}
                                            type="text"
                                            value={NumberTools.transformToCurrency(SessionStateManager.getSessionValue(this.PERCENTAGE_FACT_ID + '_' + parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx)))}
                                            onClick={(evt) => {
                                                if (this.props.captureType !== undefined && this.props.captureType !== null && this.props.captureType == 'RESEARCHER_UPDATE') {
                                                    this.handleOnChange(evt, this.PERCENTAGE_FACT_ID, parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx), true);
                                                }
                                            }}
                                            onKeyUp={(event) => { if (!/[0-9|\.]/.test(event.key) || (this.props.captureType !== undefined && this.props.captureType !== null && this.props.captureType == 'RESEARCHER_UPDATE')) { event.preventDefault(); } }}
                                            onChange={evt => this.handleOnChange(evt, this.PERCENTAGE_FACT_ID, parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx), true)}
                                            onBlur={this.handleOnBlur}
                                            questionId={this.props.questionState.question.id}
                                            ordinalEntry={0}
                                            questionFactId={this.PERCENTAGE_FACT_ID}
                                            placeholder={0}
                                        />
                                    </div>
                                </td>
                            </tr>
                        ))}
                        <tr key={rndTable + (tableRowKey++)}>
                            <td align='left' colSpan='2'>
                                <div>
                                    <span className={styles.cellHint}>
                                        <span className={styles.normalText}>
                                            <img
                                                src={addButton}
                                                alt="add row"
                                                onClick={(evt) => this.handleAddOutsourcedToRow(evt, rowFactIds)}
                                            />
                                            &nbsp;&nbsp; {'Add '}
                                            <input
                                                type="number"
                                                defaultValue="1"
                                                min="1"
                                                max={this.CONFIG_DEFAULT_MAXIMUM_ROWS_TO_ADD}
                                                style={{ width: '60px', maxHeight: '20px', textAlign: 'center', border: '1px solid #ccc', borderRadius: '3px' }}
                                                ref={input => this.rowCountInput = input}
                                            /> additional rows
                                        </span>
                                        <span className={styles.tooltiptext}>
                                            {'A maximum of ' + this.CONFIG_DEFAULT_MAXIMUM_ROWS_TO_ADD + ' additional rows may be added at one time.'}
                                        </span>
                                    </span>
                                </div>
                                <br />
                                <div>
                                    <span className={styles.cellHint}>
                                        <span className={styles.normalText}>
                                            <img
                                                src={deleteButton}
                                                alt="delete row"
                                                onClick={this.handleRemoveOutsourcedToRow}
                                            />
                                            &nbsp;&nbsp; {'Remove last row only.'}
                                        </span>
                                        <span className={styles.tooltiptext}>
                                            {'Clicking this button will remove the last row from the table.'}<br />
                                            {'Note: The first 3 rows will always remain visible, as this is the configured mininmum rows to display. Any rows that were previously created may also remain visible.'}
                                        </span>
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div className={styles.flexCenterFitContent}>
                                    <span className="inputRandSign">R</span>
                                    <input
                                        min='0'
                                        prefix='R'
                                        type="text"
                                        value={NumberTools.transformToCurrency(this.calculatePercentageTotal(this.PERCENTAGE_FACT_ID))}
                                        id="d8"
                                        name={this.props.questionState.question.id}
                                        readOnly
                                    />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        }
    }
}
export default RnDOutsourcedQuestion;

function UpdateAuditDialog(props) {
    const dialog = useDialog();

    let componentRef = null;
    let result = {};
    result.confirmed = false;

    return (
        <div>
            <div
                className={styles.updateAuditDialogOverlay}
                ref={(response) => (componentRef = response)}
            >
                <UpdateDialog
                    {...props}
                    onChangeSourceOfData={(evt, newValue) => {
                        result.newValue = newValue;
                        result.sourceOfData = evt.target.value;
                    }}
                    onChangeReason={(evt, newValue) => {
                        result.newValue = newValue;
                        result.reason = evt.target.value
                    }}
                    onChangeNewValue={(evt) => {
                        result.newValue = evt.target.value
                    }}
                />
            </div>

            <div>
                <button
                    type="button"
                    className="btnBack"
                    onClick={(evt) => {
                        result.confirmed = false;
                        dialog.close(result);
                    }}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    className="btnNext"
                    onClick={(evt) => {
                        if (
                            result.sourceOfData === undefined || result.sourceOfData == null || result.sourceOfData.trim() == "" ||
                            result.reason === undefined || result.reason == null || result.reason.trim() == ""
                        ) {
                            SupportAlert.displayAlert('Required', 'Source of data and Reason are required fields.');
                        } else {
                            result.confirmed = true;
                            dialog.close(result);
                        }
                    }}
                >
                    Continue
                </button>
            </div>
        </div>
    );
}
